import * as APIUtil from "../../util/auth/sessionAPIUtil";
import * as currencyActions from "../../redux/actions/currencyActions";
import { clearToken, extractRefreshToken, safeRemoveStorageItem, setSession, updateAccessToken } from "../../util/auth/tokenStorage";
import { removeAuthParamsFromCurrentUrl } from "../../util/auth/authUrl";

export const RECEIVE_CURRENT_USER = "RECEIVE_CURRENT_USER";
export const RECEIVE_SESSION_ERRORS = "RECEIVE_SESSION_ERRORS";
export const RECEIVE_USER_LOGOUT = "RECEIVE_USER_LOGOUT";
export const RECEIVE_USER_SIGN_IN = "RECEIVE_USER_SIGN_IN";
export const REFRESH_TOKEN = "REFRESH_TOKEN";
export const RECEIVE_TOKEN_DATA = "RECEIVE_TOKEN_DATA";
export const SET_GOTO_CHANGEPASS = "SET_GOTO_CHANGEPASS";
export const RECEIVE_ADDITIONAL_SETTINGS = "RECEIVE_ADDITIONAL_SETTINGS";

const SECURE_SESSION_ERROR = [
  "Login succeeded, but the browser could not secure your session. Please reload the application or contact support.",
];

// The one-time credential has already been stripped from the URL by the time
// this is dispatched, so the user cannot retry by reloading. Say what actually
// went wrong: sessionErrorsReducer collapses any non-array payload to the
// username/password message, which is wrong here — no credentials were typed.
const LINK_SIGN_IN_ERROR = [
  "This sign-in link is no longer valid. Please log in or request a new one.",
];

const persistAuthenticatedSession = async (session, dispatch) => {
  try {
    await setSession(session);
    return true;
  } catch (error) {
    // Never fall back to plaintext storage. Also ensure a previous token
    // cannot remain active after a new login failed to persist securely.
    clearToken();
    APIUtil.setAuthToken(false);
    dispatch(receiveErrors(SECURE_SESSION_ERROR));
    return false;
  }
};

export const setGotochangepass = (goto) => ({
  type: SET_GOTO_CHANGEPASS,
  goto,
});
export const receiveCurrentUser = (currentUser) => ({
  type: RECEIVE_CURRENT_USER,
  currentUser,
});

export const receiveUserSignIn = (user) => ({
  type: RECEIVE_USER_SIGN_IN,
  user,
});

export const receiveErrors = (errors) => ({
  type: RECEIVE_SESSION_ERRORS,
  errors,
});

export const logoutUser = () => ({
  type: RECEIVE_USER_LOGOUT,
});
export const receiveTokencheckresponse = (tokenArray) => ({
  type: RECEIVE_TOKEN_DATA,
  tokenArray
});

export const receiveAdditionalSettings = (additionalSettings) => ({
  type: RECEIVE_ADDITIONAL_SETTINGS,
  additionalSettings
});

// export const signup = (user) => (dispatch) => {
//   console.log(user);

//   return APIUtil.signup(user)
//     .then(
//       () => dispatch(receiveUserSignIn(user)),
//       (err) => dispatch(receiveErrors(err.response.data))
//     )
//     .then(() => dispatch(login(user)));
// };

export const login = (user) => (dispatch) =>
  APIUtil.login(user)
    .then(async (res) => {
      if (res.data.status == "401") throw ("invalid response");
      const { token } = res.data;
      if (!(await persistAuthenticatedSession(res.data, dispatch))) return false;
      let language = 'en'
      if(res.data.customerPortalSettings?.translate === '1'){
        language = res.data.customerPortalSettings.language
        deleteCookie('googtrans');
        setCookie('googtrans', `/en/${language}`, 1);
      }else{
        deleteCookie('googtrans');
        setCookie('googtrans', `/en`, 1);
      }
      APIUtil.setAuthToken(token);
      dispatch(currencyActions.setUserCurrency(res.data));
      const decoded = res.data;
      if (decoded.reset == "1") {
        dispatch(setGotochangepass(true));
      }
      dispatch(receiveCurrentUser(decoded));
      return true;
    })
    .catch((err) => {
      dispatch(receiveErrors(err));
    });
export const loginByToken = (Urltoken) => (dispatch) => {
  // The credential is already captured in Urltoken. Remove it before making
  // the request so failures cannot leave it in the address bar/history.
  removeAuthParamsFromCurrentUrl();
  return APIUtil.loginBytoken(Urltoken)
    .then(async (res) => {
      if (res.data.status == "401") throw ("invalid response");
      const { token } = res.data;
      if (!(await persistAuthenticatedSession(res.data, dispatch))) return false;
      let language = 'en'
      if(res.data.customerPortalSettings?.translate === '1'){
        language = res.data.customerPortalSettings.language
        deleteCookie('googtrans');
        setCookie('googtrans', `/en/${language}`, 1);
      }else{
        deleteCookie('googtrans');
        setCookie('googtrans', `/en`, 1);
      }
      APIUtil.setAuthToken(token);
      window.location.reload()
      return true;
    })
    .catch((err) => {
      dispatch(receiveErrors(LINK_SIGN_IN_ERROR));
      return false;
    });
};
export const validateToken = (token) => (dispatch) =>
  APIUtil.validateTokenApi(token)
    .then((res) => {
      if(res.status==200){
        if(res.data.status=="success"){
          dispatch(receiveTokencheckresponse({isvalid:true,ftoken:res.data.extra}))
        }else{
          dispatch(receiveTokencheckresponse({isvalid:false,ftoken:null}))
        }
      }
    })
    .catch((err) => {
      dispatch(receiveTokencheckresponse({isvalid:false,ftoken:null}))
    });

export const logout = () => (dispatch) => {
  clearToken();
  safeRemoveStorageItem(localStorage, "cpPendingArtwork");
  APIUtil.setAuthToken(false);
  dispatch(logoutUser());
};

export const refreshToken = () => dispatch => {
  return APIUtil.refreshToken()
    .then(async res => {
      const token = extractRefreshToken(res.data);
      if (res.data.status && token) {
        const updatedSession = await updateAccessToken(token);
        APIUtil.setAuthToken(updatedSession.token);
        dispatch(receiveCurrentUser(updatedSession));
        return true;
      } else {
        dispatch(logout());
        return false;
      }
    }).catch(error => {
      dispatch(logout());
      return false;
    })
}


export const getAdditionalConfig =  () => dispatch => {
  // Returns the promise and always handles rejection. The auth interceptor now
  // rejects the request when a session refresh fails, and this is dispatched
  // during boot, so an uncaught rejection here surfaces as an unhandled
  // promise rejection instead of a handled logout.
  return APIUtil.fetchFieldSettings( {"termIn": {"fieldName":["customerPo","quoteCustomerPo"]}}).then(x => {
    dispatch(receiveAdditionalSettings(x.data))
  }).catch(error => {
    // Keep diagnostics useful without printing the response, request config,
    // authorization header, or any customer data.
    console.error("Customer Portal could not load additional field configuration.");
    throw error;
  })
}

const setCookie = (name, value, days) => {
  let expires = "";
  if (days) {
    const date = new Date();
    date.setTime(date.getTime() + (days * 24 * 60 * 60 * 1000));
    expires = "; expires=" + date.toUTCString();
  }
  document.cookie = name + "=" + (value || "") + expires + "; path=/";
};

const deleteCookie = (name) => {
  document.cookie = name + '=; expires=Thu, 01 Jan 1970 00:00:00 UTC; path=/;';
};
